import { ScriptLoadingStates, useScript } from "@/utils/hooks/useScript.hook";

type Props = { cmsIdentifier: string };

const ParcelPerform = ({ cmsIdentifier }: Props) => {
    const { status } = useScript({
        src: "https://tracking.parcelperform.com/pp-widget.js",
        id: "parcel-perform"
    });

    if (status === ScriptLoadingStates.Ready) {
        return (
            <div
                id="pp-widget-root"
                data-cms-slug={cmsIdentifier}
            ></div>
        );
    }
    return null;
};

export { ParcelPerform };
